<template>
  <div class="box">
    <van-form>
      <van-field v-model="info.userName" disabled name="被保险人姓名" label="被保险人姓名" placeholder="被保险人姓名" :rules="[{ required: true, message: '请填写被保险人姓名' }]" />
      <van-field v-model="info.userIdCard" disabled name="身份证号/组织机构代码" label="身份证号/组织机构代码" placeholder="身份证号/组织机构代码" :rules="[{ required: true, message: '请填写身份证号/组织机构代码' }]" />
      <!-- <van-field v-model="form.idcard" required disabled name="身份证号" label="身份证号" placeholder="身份证号" :rules="[{ required: true, message: '请填写身份证号' }]" /> -->
      <van-field name="uploader" required label="身份证正面">
        <template #input>
          <van-uploader v-model="fileList1" accept="image/*" :max-count="1" :after-read="afterReadIDcardFornt">
            <!-- <van-button icon="plus" plain type="danger">上传图片</van-button> -->
          </van-uploader>
        </template>
      </van-field>
      <van-field name="uploader" required label="身份证反面">
        <template #input>
          <van-uploader v-model="fileList2" accept="image/*" :max-count="1" :after-read="afterReadIDcardBack">
            <!-- <van-button icon="plus" plain type="danger">上传图片</van-button> -->
          </van-uploader>
        </template>
      </van-field>
      <van-field v-model="info.phone" disabled name="联系方式" label="联系方式" placeholder="联系方式" :rules="[{ required: true, message: '请填写联系方式' }]" />
      <van-field v-model="info.policyholder" disabled name="投保人" label="投保人" placeholder="投保人" :rules="[{ required: true, message: '请填写投保人' }]" />
      <van-field v-model="info.area" disabled name="保险数量（亩/株）" label="保险数量（亩/株）" placeholder="保险数量（亩/株）" :rules="[{ required: true, message: '请填写保险数量（亩/株）' }]" />
      <van-field v-model="info.premium" disabled name="农户自交保险费" label="农户自交保险费" placeholder="农户自交保险费" :rules="[{ required: true, message: '请填写农户自交保险费' }]" />
      <!-- <van-field v-model="form.cardholderName" required name="持卡人姓名" label="持卡人姓名" placeholder="持卡人姓名" :rules="[{ required: true, message: '请填写持卡人姓名' }]" /> -->
      <van-field v-model="form.bankCard" type="digit" required name="卡号" label="卡号" placeholder="卡号" :rules="[{ required: true, message: '请输入持卡人银行卡号' }]" />
      <van-field v-model="form.bankOfDeposit" required name="开户行" label="开户行" placeholder="" :rules="[{ required: true, message: '请输入持卡人开户行' }]" />
      <van-field name="uploader" required label="银行卡正面">
        <template #input>
          <van-uploader v-model="fileList3" accept="image/*" :max-count="1" :after-read="afterReadBankCard">
            <!-- <van-button icon="plus" plain type="danger">上传图片</van-button> -->
          </van-uploader>
        </template>
      </van-field>
      <van-field name="uploader" required label="银行卡反面">
        <template #input>
          <van-uploader v-model="fileList4" accept="image/*" :max-count="1" :after-read="afterRead">
            <!-- <van-button icon="plus" plain type="danger">上传图片</van-button> -->
          </van-uploader>
        </template>
      </van-field>
      <!-- <van-field v-model="form.bankReservedPhone" type="tel" required name="预留手机号" label="预留手机号" placeholder="预留手机号" :rules="[{ required: true, message: '请填写预留手机号' }]" /> -->
      <!-- <van-field v-model="form.sms" type="tel" required name="短信验证码" label="短信验证码" placeholder="短信验证码" :rules="[{ required: true, message: '请输入短信验证码' }]">
        <template #button>
          <van-button size="small" type="primary">发送验证码</van-button>
        </template>
      </van-field> -->
      <div class="tips">
        <van-checkbox v-model="checked" icon-size="18px" checked-color="#E99D42"
          >确认信息前请阅读<span style="color: #e99d42;" @click.stop="gotoArticle1">《低温指数保险条款》</span><span style="color: #e99d42;" @click="gotoArticle2">《热带气旋风力指数保险条款》</span><span style="color: #e99d42;" @click="gotoAgreement">《服务协议》</span></van-checkbox
        >
      </div>
      <div class="confirm">
        <van-button class="confirm-btn" color="#E99D42" @click="handletoSignature()">
          验证并签字
        </van-button>
      </div>
    </van-form>
    <van-popup v-model="show" :style="{ height: '100%' }" :close-on-click-overlay="false">
      <div class="choose-box">
        <div class="title">请选择需要申报信息的保单</div>
        <div class="item" v-for="(item, index) in this.insuranceList" :key="item.policyholder" @click="handleClickInsurance(index)">{{ item.batchName + ' ' + item.policyholder }}<span v-if="item.isCompleted == 1">(已提交)</span><span v-if="item.isCompleted == 0">(未提交)</span></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { uploadFile } from '@/service/upload'
import { verifyIdCard, verifyBankCardFace } from '@/service/insurance'
import { genUesrInfo, getInfoByIdcard, getInfoByPhone } from '@/service/insurance'
export default {
  props: {},
  data() {
    return {
      insuranceList: [],
      show: false,
      userIdCard: '', // 识别的身份证正面
      userIdCardEndTime: '', // 识别的身份证反面
      bankCard: '', // 识别的银行卡号
      bankName: '', // 识别的开户行
      fileList4: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],
      info: {
        userName: '',
        idcard: '',
        phone: '',
        // address: '',
        area: '',
        premium: '',
        name: '',
        bankNumber: '',
        prephone: ''
      },
      form: {
        userId: '', // 用户id
        frontSideOfIdCard: '', // 身份证正面
        backSideOfIdCard: '', // 身份证反面
        bankCard: '', // 银行卡号
        bankOfDeposit: '',
        cardholderIdCard: '', // 持卡人身份证
        frontSideOfBankCard: '', // 银行卡正面
        backSideOfBankCard: '', // 银行卡反面
        signaturePhoto: '', // 签名照片
        endDate: '' // 身份证截止日期
      },
      checked: false
    }
  },
  mounted() {
    genUesrInfo().then((res) => {
      console.log(res.data, 'res.data')
      console.log(res.data.user.nickName, 'res.data.user.nickName')
      if (res.data.user.nickName === '身份证登录') {
        // 根据身份证获取保单信息,如果数量超过1则需要选择
        getInfoByIdcard(sessionStorage.getItem('idcard')).then((res) => {
          this.insuranceList = res.data
          if (this.insuranceList.length == 1) {
            if (this.insuranceList[0].isCompleted == 1) {
              this.$toast.fail('该项目已完成申报！')
              this.$router.replace('/insurance')
              return false
            }
            this.form = {
              userId: this.insuranceList[0].userId,
              userName: this.insuranceList[0].userName,
              frontSideOfIdCard: '', // 身份证正面
              backSideOfIdCard: '', // 身份证反面
              bankCard: this.insuranceList[0].bankCard, // 银行卡号
              bankOfDeposit: this.insuranceList[0].bankOfDeposit, // 开户行
              cardholderIdCard: this.insuranceList[0].userIdCard, // 持卡人身份证
              frontSideOfBankCard: '', // 银行卡正面
              backSideOfBankCard: '', // 银行卡反面
              signaturePhoto: '', // 签名照片
              endDate: '' // 身份证截止日期
            }
            this.info = {
              userName: this.insuranceList[0].userName,
              userIdCard: this.insuranceList[0].userIdCard,
              phone: this.insuranceList[0].phone,
              policyholder: this.insuranceList[0].policyholder,
              area: this.insuranceList[0].insuranceAcreage,
              premium: this.insuranceList[0].paymentAmount + '元',
              name: '',
              bankNumber: '',
              prephone: ''
            }
          } else {
            this.show = true
          }
        })
      }
      if (res.data.user.nickName === '手机号登录') {
        // 根据手机号获取保单信息,如果数量超过1则需要选择
        getInfoByPhone(res.data.user.phonenumber).then((res) => {
          this.insuranceList = res.data
          if (this.insuranceList.length == 1) {
            if (this.insuranceList[0].isCompleted == 1) {
              this.$toast.fail('该项目已完成申报！')
              this.$router.replace('/insurance')
              return false
            }
            this.form = {
              userId: this.insuranceList[0].userId,
              userName: this.insuranceList[0].userName,
              frontSideOfIdCard: '', // 身份证正面
              backSideOfIdCard: '', // 身份证反面
              bankCard: this.insuranceList[0].bankCard, // 银行卡号
              bankOfDeposit: this.insuranceList[0].bankOfDeposit, // 开户行
              cardholderIdCard: this.insuranceList[0].userIdCard, // 持卡人身份证
              frontSideOfBankCard: '', // 银行卡正面
              backSideOfBankCard: '', // 银行卡反面
              signaturePhoto: '', // 签名照片
              endDate: '' // 身份证截止日期
            }
            this.info = {
              userName: this.insuranceList[0].userName,
              userIdCard: this.insuranceList[0].userIdCard,
              phone: this.insuranceList[0].phone,
              policyholder: this.insuranceList[0].policyholder,
              area: this.insuranceList[0].insuranceAcreage,
              premium: this.insuranceList[0].paymentAmount + '元',
              name: '',
              bankNumber: '',
              prephone: ''
            }
          } else {
            this.show = true
          }
        })
      }
    })
  },
  methods: {
    handleClickInsurance(index) {
      console.log(index, 'index')
      this.form = {
        userId: this.insuranceList[index].userId,
        userName: this.insuranceList[index].userName,
        frontSideOfIdCard: '', // 身份证正面
        backSideOfIdCard: '', // 身份证反面
        bankCard: this.insuranceList[index].bankCard, // 银行卡号
        bankOfDeposit: this.insuranceList[index].bankOfDeposit, // 开户行
        cardholderIdCard: this.insuranceList[index].userIdCard, // 持卡人身份证
        frontSideOfBankCard: '', // 银行卡正面
        backSideOfBankCard: '', // 银行卡反面
        signaturePhoto: '', // 签名照片
        endDate: '' // 身份证截止日期
      }
      this.info = {
        userName: this.insuranceList[index].userName,
        userIdCard: this.insuranceList[index].userIdCard,
        phone: this.insuranceList[index].phone,
        policyholder: this.insuranceList[index].policyholder,
        area: this.insuranceList[index].insuranceAcreage,
        premium: this.insuranceList[index].paymentAmount + '元',
        name: '',
        bankNumber: '',
        prephone: ''
      }
      if (this.insuranceList[index].isCompleted == 1) {
        this.$toast.fail('该项目已完成申报！')
        return false
      }
      this.show = false
    },
    // 跳转完成签名
    handletoSignature() {
      if (this.fileList1 && this.fileList1.length > 0) {
        this.form.frontSideOfIdCard = this.fileList1[0].url
      }
      if (this.fileList2 && this.fileList2.length > 0) {
        this.form.backSideOfIdCard = this.fileList2[0].url
      }
      if (this.fileList3 && this.fileList3.length > 0) {
        this.form.frontSideOfBankCard = this.fileList3[0].url
      }
      if (this.fileList4 && this.fileList4.length > 0) {
        this.form.backSideOfBankCard = this.fileList4[0].url
      }
      if (
        this.form.frontSideOfIdCard == '' ||
        this.form.backSideOfIdCard == '' ||
        this.form.frontSideOfBankCard == '' ||
        this.form.backSideOfBankCard == '' ||
        this.form.frontSideOfIdCard == null ||
        this.form.backSideOfIdCard == null ||
        this.form.frontSideOfBankCard == null ||
        this.form.backSideOfBankCard == null
      ) {
        this.$toast('请上传相对应的图片')
        return false
      }
      // 判断身份证和上传的身份证是否相同
      if (this.userIdCard != this.form.cardholderIdCard) {
        this.$toast('请上传与身份证号相同的身份证照片')
        return false
      }
      // 判断身份证是否过期
      if (!this.validDate(this.userIdCardEndTime)) {
        this.$toast('请上传有效期限内身份证照片')
        return false
      }
      if (!this.validBankCardNumber(this.form.bankCard)) {
        this.$toast('请输入正确的银行卡号')
        return false
      }
      if (!this.checked) {
        this.$toast('确认信息前请阅读《服务协议》')
        return false
      }
      // 判断输入银行卡号和上传银行卡号是否相同
      if (this.bankCard != this.form.bankCard) {
        if (this.bankCard == '' || this.bankCard == null || !this.bankCard) {
          this.$toast('无法正确识别银行卡号，请重新上传银行卡照片')
        }
        this.$toast('请输入与上传银行卡相匹配的银行卡号或重新上传银行卡照片')
        return false
      }
      this.$dialog
        .confirm({
          message: `识别开户行为${this.bankName}，确认是否提交`
        })
        .then(() => {
          console.log('提交')
          sessionStorage.setItem('form', JSON.stringify(this.form))
          sessionStorage.setItem('info', JSON.stringify(this.info))
          this.$router.replace('/recognition')
        })
        .catch(() => {
          return false
        })
    },
    validBankCardNumber(bankCardNumber) {
      // 定义正则表达式模式
      const pattern = /^\d{16,19}$/
      return pattern.test(bankCardNumber)
    },
    validatePhoneNumber(phone) {
      const regex = /^1\d{10}$/
      return regex.test(phone)
    },
    validDate(str) {
      // 获取当前年月日
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      let day = date.getDate()
      if (day < 10) {
        day = '0' + day
      }
      let timestr = year.toString() + month.toString() + day.toString()
      if (timestr <= str) {
        // 未过期
        console.log('true')
        return true
      } else {
        console.log('false')
        return false
      }
    },
    gotoArticle1() {
      this.$router.push('/article1')
    },
    gotoArticle2() {
      this.$router.push('/article2')
    },
    gotoAgreement() {
      this.$router.push('/agreement')
    },
    // beforeRead(file) {
    //   if (file.type !== 'image/') {
    //     this.$toast('请上传图片')
    //     return false
    //   }
    // },
    afterRead(file) {
      let fileArr = []
      if (Array.isArray(file)) {
        // 多个文件
        fileArr = file
      } else {
        // 单个文件
        fileArr = [file]
      }
      for (let i = 0; i < fileArr.length; i++) {
        const fileItem = fileArr[i]
        this.preUpload(fileItem)
      }
    },
    // 上传身份证正面
    afterReadIDcardFornt(file) {
      let fileArr = []
      if (Array.isArray(file)) {
        // 多个文件
        fileArr = file
      } else {
        // 单个文件
        fileArr = [file]
      }
      for (let i = 0; i < fileArr.length; i++) {
        const fileItem = fileArr[i]
        this.fileStatusSet(fileItem, 'uploading', '上传中...')
        let img = new Image()
        img.src = fileItem.content
        img.onload = () => {
          //压缩图片
          let imgName = fileItem.file.name
          let fileOrigin = fileItem
          let originWidth = img.width, // 压缩后的宽
            originHeight = img.height,
            maxWidth = 1000,
            // maxHeight = 1000, //压缩尺寸
            quality = 0.6, // 压缩质量
            canvas = document.createElement('canvas'),
            drawer = canvas.getContext('2d')
          let base64 = ''
          // 判断原图片大小
          if (originWidth > 1000) {
            let targetWidth = maxWidth
            let targetHeight = (1000 * originHeight) / originWidth
            canvas.width = targetWidth
            canvas.height = targetHeight
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height)
            base64 = canvas.toDataURL('image/jpeg', quality) // 压缩后的base64图片
          } else {
            base64 = img.src
          }
          //压缩完成上传图片  base64转blob
          let file = this.dataURLtoBlob(base64)
          // blob转file
          let fileCompressed = this.blobToFile(file, imgName)
          let formData = new FormData()
          formData.append('file', fileCompressed, fileCompressed.name)
          formData.append('type', 1)
          verifyIdCard(formData)
            .then((res) => {
              this.userIdCard = res.data.userIdCard
              this.fileStatusSet(fileOrigin, 'done', '上传成功', res.data.sysOssUploadVo.url)
            })
            .catch((err) => {
              this.fileStatusSet(fileOrigin, 'failed', '上传失败')
              this.$toast.fail(err)
            })
        }
      }
    },
    // 上传身份证反面
    afterReadIDcardBack(file) {
      let fileArr = []
      if (Array.isArray(file)) {
        // 多个文件
        fileArr = file
      } else {
        // 单个文件
        fileArr = [file]
      }
      for (let i = 0; i < fileArr.length; i++) {
        const fileItem = fileArr[i]
        this.fileStatusSet(fileItem, 'uploading', '上传中...')
        let img = new Image()
        img.src = fileItem.content
        img.onload = () => {
          //压缩图片
          let imgName = fileItem.file.name
          let fileOrigin = fileItem
          let originWidth = img.width, // 压缩后的宽
            originHeight = img.height,
            maxWidth = 1000,
            // maxHeight = 1000, //压缩尺寸
            quality = 0.6, // 压缩质量
            canvas = document.createElement('canvas'),
            drawer = canvas.getContext('2d')
          let base64 = ''
          // 判断原图片大小
          if (originWidth > 1000) {
            let targetWidth = maxWidth
            let targetHeight = (1000 * originHeight) / originWidth
            canvas.width = targetWidth
            canvas.height = targetHeight
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height)
            base64 = canvas.toDataURL('image/jpeg', quality) // 压缩后的base64图片
          } else {
            base64 = img.src
          }
          //压缩完成上传图片  base64转blob
          let file = this.dataURLtoBlob(base64)
          // blob转file
          let fileCompressed = this.blobToFile(file, imgName)
          let formData = new FormData()
          formData.append('file', fileCompressed, fileCompressed.name)
          formData.append('type', 2)
          verifyIdCard(formData)
            .then((res) => {
              this.userIdCardEndTime = res.data.userIdCardEndTime
              // 把时间格式从20241212改成2024/12/12这种类型
              this.form.endDate = this.userIdCardEndTime.replace(/(\d{4})(\d{2})(\d{2})/, '$1/$2/$3')
              // 计算半年后的日期（180天）
              let halfYearLater = new Date()
              halfYearLater.setDate(halfYearLater.getDate() + 180)
              let halfYearStr = halfYearLater.getFullYear().toString() + (halfYearLater.getMonth() + 1 < 10 ? '0' + (halfYearLater.getMonth() + 1) : halfYearLater.getMonth() + 1).toString() + (halfYearLater.getDate() < 10 ? '0' + halfYearLater.getDate() : halfYearLater.getDate()).toString()
              if (this.userIdCardEndTime <= halfYearStr) {
                this.$toast('您的身份证将在近期过期')
              }
              this.fileStatusSet(fileOrigin, 'done', '上传成功', res.data.sysOssUploadVo.url)
            })
            .catch((err) => {
              this.fileStatusSet(fileOrigin, 'failed', '上传失败')
              this.$toast.fail(err)
            })
        }
      }
    },
    // 上传银行卡
    afterReadBankCard(file) {
      let fileArr = []
      if (Array.isArray(file)) {
        // 多个文件
        fileArr = file
      } else {
        // 单个文件
        fileArr = [file]
      }
      for (let i = 0; i < fileArr.length; i++) {
        const fileItem = fileArr[i]
        this.fileStatusSet(fileItem, 'uploading', '上传中...')
        let img = new Image()
        img.src = fileItem.content
        img.onload = () => {
          //压缩图片
          let imgName = fileItem.file.name
          let fileOrigin = fileItem
          let originWidth = img.width, // 压缩后的宽
            originHeight = img.height,
            maxWidth = 1000,
            // maxHeight = 1000, //压缩尺寸
            quality = 0.6, // 压缩质量
            canvas = document.createElement('canvas'),
            drawer = canvas.getContext('2d')
          let base64 = ''
          // 判断原图片大小
          if (originWidth > 1000) {
            let targetWidth = maxWidth
            let targetHeight = (1000 * originHeight) / originWidth
            canvas.width = targetWidth
            canvas.height = targetHeight
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height)
            base64 = canvas.toDataURL('image/jpeg', quality) // 压缩后的base64图片
          } else {
            base64 = img.src
          }
          //压缩完成上传图片  base64转blob
          let file = this.dataURLtoBlob(base64)
          // blob转file
          let fileCompressed = this.blobToFile(file, imgName)
          let formData = new FormData()
          formData.append('file', fileCompressed, fileCompressed.name)
          verifyBankCardFace(formData)
            .then((res) => {
              if (res.data.bankCard == 'null' || res.data.bankCard == null || res.data.bankCard == '' || !res.data.bankCard) {
                this.$toast.fail('银行卡号识别失败，请重新上传正确银行卡')
              }
              this.bankCard = res.data.bankCard
              this.bankName = res.data.bankName
              this.form.bankOfDeposit = res.data.bankName
              this.fileStatusSet(fileOrigin, 'done', '上传成功', res.data.sysOssUploadVo.url)
            })
            .catch((err) => {
              this.fileStatusSet(fileOrigin, 'failed', '上传失败')
              this.$toast.fail(err)
            })
        }
      }
    },
    preUpload(fileItem) {
      this.fileStatusSet(fileItem, 'uploading', '上传中...')
      let img = new Image()
      img.src = fileItem.content
      img.onload = () => {
        //压缩图片
        let imgName = fileItem.file.name
        let fileOrigin = fileItem
        this.compressImg(img, imgName, fileOrigin)
      }
    },
    //将base64转换为blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    //将blob转换为file
    blobToFile(theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    fileStatusSet(fileOrigin, status, message, url) {
      fileOrigin.url = url
      fileOrigin.status = status
      fileOrigin.message = message
    },
    //压缩图片并上传
    compressImg(img, imgName, fileOrigin) {
      let originWidth = img.width, // 压缩后的宽
        originHeight = img.height,
        maxWidth = 1000,
        // maxHeight = 1000, //压缩尺寸
        quality = 0.6, // 压缩质量
        canvas = document.createElement('canvas'),
        drawer = canvas.getContext('2d')
      let base64 = ''
      // 判断原图片大小
      if (originWidth > 1000) {
        let targetWidth = maxWidth
        let targetHeight = (1000 * originHeight) / originWidth
        canvas.width = targetWidth
        canvas.height = targetHeight
        drawer.drawImage(img, 0, 0, canvas.width, canvas.height)
        base64 = canvas.toDataURL('image/jpeg', quality) // 压缩后的base64图片
      } else {
        base64 = img.src
      }
      //压缩完成上传图片  base64转blob
      let file = this.dataURLtoBlob(base64)
      // blob转file
      let fileCompressed = this.blobToFile(file, imgName)
      this.uploadFinalFile(fileCompressed, fileOrigin)
    },
    uploadFinalFile(file, fileOrigin) {
      let formData = new FormData()
      formData.append('file', file, file.name)
      uploadFile(formData)
        .then((res) => {
          this.fileStatusSet(fileOrigin, 'done', '上传成功', res.data.url)
        })
        .catch(() => {
          this.fileStatusSet(fileOrigin, 'failed', '上传失败')
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
body{
  width: 100%
  .box{
    height: 100vh
    overflow-y: scroll
    height: 100%
    // padding: 30px 0
    .tips{
      margin: 30px
      font-size: 26px
    }
    .confirm{
        margin: 30px auto
        text-align: center
        .confirm-btn{
          // border-radius: 20px
          width: 720px
        }
      }
  }
  .van-popup{
    width: 100vw
    height: 100vh
  }
  .choose-box{
    width: 100%
    height: 100%
    text-align: center
    padding-top: 400px
    .title{
      font-size: 32px
      font-weight: bold
      margin: 0 0 60px 0
    }
    .item{
      color: #fff
      width: 500px
      line-height: 100px
      margin: 20px auto
      background: #E99D42
    }
  }
}
</style>
